import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Cabecera con la que el backend sabe a qué cliente pertenece el request.
 */
export const TENANT_HEADER = 'X-Tenant-Domain';

/**
 * Envía el dominio del navegador en cada llamada al backend.
 *
 * <p>El frontend tiene un dominio por cliente (`cliente.softrent.cl`), pero el
 * backend tiene uno solo: agregar dominios por cliente también ahí sería
 * insostenible de operar. Por eso el tenant viaja en una cabecera y no se deduce
 * de la URL a la que se le pega.
 *
 * <p>Va primero en la cadena: si el backend no puede resolver el tenant, no hay
 * nada que reintentar ni token que refrescar.
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    req.clone({
      setHeaders: { [TENANT_HEADER]: window.location.hostname }
    })
  );
};
